import { ChessRookIcon } from './ChessRookIcon';

/**
 * author: Michael Richins
 * id D1FA251F-4332-4BA9-8742-F194C0B0BF28
 * name chess-rook
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chess-rook.svg
 * tags
 * - Gaming / RPG 
 */
export const ChessCastleIcon = ChessRookIcon;
export default ChessCastleIcon